import React from "react";

const Apple = ({size = 24, ...rest }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M14.4992 7.80264C15.0453 7.59762 15.5708 7.42483 16.3055 7.41589C16.3238 7.41689 16.3422 7.4174 16.3607 7.4174C17.1514 7.4174 18.0376 7.74175 18.8266 8.38759C18.8237 8.39385 18.8205 8.40051 18.8167 8.40753C18.7971 8.44421 18.7698 8.48018 18.7377 8.51002C16.0786 10.9869 16.5971 15.3144 19.5001 17.257C19.5748 17.307 19.6229 17.3751 19.6415 17.4246C19.6449 17.4337 19.6467 17.4406 19.6477 17.4454C19.416 17.9201 19.194 18.308 18.8001 18.9075L18.7999 18.9079C18.3637 19.5722 17.8837 20.2469 17.3559 20.7534C16.8219 21.266 16.3594 21.4906 15.957 21.4965H15.9351C15.5408 21.4965 15.3134 21.3927 14.8517 21.182C14.8244 21.1696 14.7962 21.1567 14.7672 21.1435C14.2152 20.8924 13.5194 20.611 12.4082 20.611H12.3801V20.611L12.3745 20.611C11.2557 20.6172 10.5493 20.8971 9.98804 21.146C9.95873 21.159 9.9303 21.1717 9.90267 21.184C9.42741 21.3953 9.18832 21.5016 8.78616 21.5016H8.76407C8.33406 21.4956 7.88092 21.2837 7.38069 20.8245C6.87758 20.3627 6.41724 19.733 5.98559 19.0729L5.9854 19.0726C4.8381 17.3195 4.21165 15.4235 4.04481 13.7141C3.87629 11.9874 4.18271 10.5409 4.78393 9.613C5.71827 8.17856 7.13568 7.42209 8.34366 7.42209C8.97631 7.42209 9.50168 7.59073 10.1257 7.81217C10.1649 7.82608 10.2049 7.84038 10.2457 7.85496C10.8171 8.05928 11.539 8.3174 12.3604 8.3174C13.1534 8.3174 13.8152 8.06409 14.3353 7.86501C14.3916 7.84345 14.4463 7.82254 14.4992 7.80264Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M15.9493 1.5C14.8243 1.57641 13.5118 2.29266 12.7431 3.22781C12.0456 4.07531 11.4718 5.3325 11.6968 6.55172H11.7868C12.985 6.55172 14.2112 5.83031 14.9275 4.90594C15.6175 4.02609 16.1406 2.77922 15.9493 1.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Apple;
